export default {
	SIMILAR: 'SIMILAR',
	BOW: 'BOW',
	PVREC_ANON: 'PVREC_ANON',
	PVREC_CROSS_CAT: 'PVREC_CROSS_CAT',
} as const;
